import { render, staticRenderFns } from "./ModalCadastroFaseExecucao.vue?vue&type=template&id=4646ddd0"
import script from "./ModalCadastroFaseExecucao.vue?vue&type=script&lang=js"
export * from "./ModalCadastroFaseExecucao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports